import React from "react";
import { Icon } from "../../assets/Icons.tsx";
import styles from "./infoCard.module.scss";

interface InfoCardProps {
  text: string;
  icon?: string;
  height: string;
  subText?: string;
  contentAlign?: string;
  padding?: string;
  bgColor?:string
}

const InfoCard: React.FC<InfoCardProps> = ({
  text,
  icon,
  height,
  subText,
  contentAlign = "center",
  padding,
  bgColor
}) => {
  return (
    <div
      className={styles.infoCardDiv}
      style={{
        height: height,
        justifyContent: contentAlign,
        alignItems: contentAlign,
        textAlign: contentAlign,
        padding: padding,
        backgroundColor: bgColor
      }}
    >
      <Icon name={icon} />
      <p className="fw-bold mb-0 heading3 text-center">{text}</p>

      {subText && <p className="para">{subText}</p>}
    </div>
  );
};

export default InfoCard;
